(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["experience"] && !Shopify.designMode) return;
  try {
    
  /* The still is the play control. Once pressed it goes, and the video under
     it plays with its own controls; when it ends the still comes back. The
     video takes the still as its poster only then: a poster attribute is
     fetched at once, below the fold or not, and the button's lazy image
     already holds the same picture. */
  if (!customElements.get('ziva-story-video')) {
    customElements.define(
      'ziva-story-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.poster = this.querySelector('.ziva-story-card__poster');
          if (!this.video || !this.poster) return;
          this.poster.addEventListener('click', () => this.play());
          this.video.addEventListener('ended', () => this.reset());
        }

        play() {
          const still = this.poster.querySelector('img');
          if (still?.currentSrc && !this.video.poster) this.video.poster = still.currentSrc;
          this.poster.hidden = true;
          this.video.controls = true;
          // Started inside the press itself, so the browser lets it play with sound.
          this.video.play().catch(() => this.reset());
          this.video.focus();
        }

        reset() {
          this.video.controls = false;
          this.poster.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-lifestyle"] && !Shopify.designMode) return;
  try {
    
  /* A looping video holds still for anyone who asks for less motion. */
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const apply = () => {
      document.querySelectorAll('video[data-reduced-motion-pause]').forEach((video) => {
        if (reduce.matches) {
          video.pause();
          video.currentTime = 0;
        } else {
          video.muted = true;
          video.play().catch(() => {});
        }
      });
    };
    apply();
    reduce.addEventListener('change', apply);
    document.addEventListener('shopify:section:load', apply);
  })();

  } catch(e) { console.error(e); }
})();
})();
